import "./CategoriesSidebar.css";
import { Card, Check } from "../../../ui";
import { categoryHasIssue } from "../../utils/ludDocuments.helpers";
export default function CategoriesSidebar({
  categories,
  selectedKey,
  restaurant,
  onSelect,
  lang,
}) {
  return (
    <Card
      className="lud-categories"
      title={lang === "ar" ? "الأقسام" : "Sections"}
      hoverable={false}
    >
      {categories.map((c) => {
        const active = c.key === selectedKey;
        return (
          <button
            key={c.key}
            type="button"
            className={`lud-categories__item ${active ? "active" : ""}`}
            onClick={() => onSelect(c.key)}
          >
            <span className="lud-categories__badge">
              {active && <Check size={14} />}
            </span>
            <span>{c.label[lang] || c.label.ar}</span>
            {categoryHasIssue(c.key, restaurant) && <i />}
          </button>
        );
      })}
    </Card>
  );
}
